<template>
  <div>
    <div style="height: 100vh;width: 100%;position: relative;">
      <div
        id="luckysheet"
        style="margin: 0px;padding: 0px;width: 100%;height: 95%;font-family: 'Book Antiqua', 'fontStyle';"
      ></div>
    </div>
  </div>
</template>

<script>
import LuckyExcel from "luckyexcel";
import axios from "axios";
// import '@/assets/js/iconfont.css';
// import '@/assets/js/luckysheet.css';
// import '@/assets/js/plugins.css';
// import '@/assets/js/pluginsCss.css';
//引入相关样式
import Cookies from "js-cookie";

export default {
  data() {
    return {
      scale: scale,
      formurl: "",
      excelView: "",
      title: "view",
      formId: "",
    };
  },

  created() {
    console.log("deptList", this.$route.query);
    this.formId = this.$route.query.id;
    this.getOriginFile(); // 获取远端文件
  },
  methods: {
    getOriginFile() {
      axios({
        url:
          window.SITE_CONFIG["apiUpURL"] +
          "/sys/sysstock/getAccessUrl?id=" +
          this.formId,
        responseType: "blob",
        headers: {
          token: Cookies.get("token") || "",
        },
      })
        .then((res) => {
          if (res.data) {
            // var data = 'http://59.110.159.111/gpweb/HK.xlsx'
            const blob = new Blob([res.data]);
            const file = new File([blob], "fileName");
            this.init(file); // 开始渲染
          } else {
            this.$message({
              message: res.msg,
              type: "error",
              duration: 2000,
            });
            this.cancel();
          }
        })
        .catch((e) => {
          this.errorTitle = "文件解析失败，请下载后使用 Excel 打开或点击重试！";
          this.errStatus = 2;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 渲染方法，接受文件对象，如果是本地文件直接传入文件即可
    init(file) {
      // luckysheet.destroy(); // 先销毁当前容器
      LuckyExcel.transformExcelToLucky(file, (exportJson) => {
        if (exportJson.sheets === null || !exportJson.sheets.length) {
          this.$message.error("无法读取excel文件的内容,当前不支持xls文件!");
          return;
        }
        console.log("exportJson.sheets", exportJson);
        // 只显示excel第1-47行（新模板48行以后为图表源数据，不展示）
        for (let s = 0; s < exportJson.sheets.length; s++) {
          const sh = exportJson.sheets[s];
          if (sh.celldata) {
            sh.celldata = sh.celldata.filter((c) => c.r < 47);
            // 全表字体设为 Book Antiqua（系统未安装该字体时浏览器自动回退默认字体）
            sh.celldata.forEach((cell) => {
              if (cell.v && typeof cell.v === "object") {
                cell.v.ff = "Book Antiqua";
              }
            });
          }
          sh.row = 47;
        }
        setTimeout(() => {
          luckysheet.create({
            container: "luckysheet",
            showinfobar: false,
            showtoolbar: false,
            // showtoolbarConfig: {
            //   font: true,
            // },
            // lang: "en",
            lang: "zh", // 设定表格语言

            data: exportJson.sheets,
            title: exportJson.info.name,
            userInfo: exportJson.info.name.creator,
            allowEdit: false,
          });

          var numberList = luckysheet.getLuckysheetfile();

          for (let index = 0; index < numberList.length; index++) {
            const element = numberList[index];
            element.zoomRatio = 0.8;

            if (element.data) {
              var elementData = element.data;
              for (let i = 0; i < elementData.length; i++) {
                const elementI = elementData[i];
                for (let j = 0; j < elementI.length; j++) {
                  const elementJ = elementI[j];
                  // if (elementJ) {
                  //   console.log("elementJ", elementJ);
                  // }

                  if (elementJ && typeof elementJ.v == "number" && i > 23) {
                    // excel第45、47行（0基索引44、46）数值原本居中，其余右对齐
                    elementJ.ht = i == 44 || i == 46 ? 0 : 2;
                  }
                  // if (elementJ && elementJ.v == "45458") {
                  //   debugger;
                  // }
                  if (
                    elementJ &&
                    elementJ.v &&
                    typeof elementJ.v == "string" &&
                    i == 2 &&
                    j == 11 &&
                    this.isNumeric(elementJ.v)
                  ) {
                    console.log("elementJ", elementJ);

                    elementJ.ct = {
                      fa: "[$-409]yyyy\\-mm\\-dd;@",
                      t: "d",
                    };
                    elementJ.m = this.getdaynumber(elementJ.v);
                    elementJ.v = elementJ.m;
                  }
                }
              }
            }
          }

          luckysheet.exitEditMode();
        }, 500);

        setTimeout(() => {
          var numberList = luckysheet.getLuckysheetfile();

          for (let index = 0; index < numberList.length; index++) {
            const element = numberList[index];
            element.zoomRatio = 0.8;
            if (element.data) {
              var elementData = element.data;
              for (let i = 0; i < elementData.length; i++) {
                const elementI = elementData[i];
                for (let j = 0; j < elementI.length; j++) {
                  const elementJ = elementI[j];

                  if (elementJ && typeof elementJ.v == "number" && i > 23) {
                    // excel第45、47行（0基索引44、46）数值原本居中，其余右对齐
                    elementJ.ht = i == 44 || i == 46 ? 0 : 2;
                  }
                  if (
                    elementJ &&
                    elementJ.v &&
                    typeof elementJ.v == "string" &&
                    i == 2 &&
                    j == 11 &&
                    this.isNumeric(elementJ.v)
                  ) {
                    console.log("elementJ", elementJ);

                    elementJ.ct = {
                      fa: "[$-409]yyyy\\-mm\\-dd;@",
                      t: "d",
                    };
                    elementJ.m = this.getdaynumber(elementJ.v);
                    elementJ.v = elementJ.m;
                  }
                }
              }
            }
          }
          // exportJson.sheets[0].status = "1;
          luckysheet.exitEditMode();
        }, 800);
      });
    },
    isNumeric(str) {
      return Number.isFinite(+str);
      // return /^\d+(\.\d+)?$/.test(str);
    },
    // gehsihua
    getdaynumber(data) {
      //       var d0 = new Date(1900,1,1).getTime();
      // var d1 = new Date(2007,6,24).getTime();
      // alert( (d1-d0)/(24*60*60*1000) +1 );

      var timenumber =
        86400000 * (data - 1) + new Date("1900-01-01 00:00:00").getTime();
      console.log("data", data);
      console.log("timenumber", timenumber);
      // 获取当前时间
      const today = new Date(timenumber);
      // 获取当前时间(today)的年份
      const year = today
        .getFullYear()
        .toString()
        .slice(-2);
      // 获取月份
      const month = String(today.getMonth() + 1).padStart(2, "0");
      // 获取当前日
      const day = String(today.getDate()).padStart(2, "0");
      // 得到年月日
      return `${month}/${day}/${year}`; //打印当前日期
    },
  },
};
</script>

<style>
#luckysheet {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 800px;
}

.luckysheet-stat-area {
  background: #fff;
}
</style>
